import { render, staticRenderFns } from "./StudentRegistrationIntake.vue?vue&type=template&id=0f4d5d02"
import script from "./StudentRegistrationIntake.vue?vue&type=script&lang=js"
export * from "./StudentRegistrationIntake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports